{
  "AGENT_MGMT": {
    "HEADER": "Agenter",
    "HEADER_BTN_TXT": "Lägg till agent",
    "LOADING": "Hämtar agentlista",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administratör",
      "AGENT": "Agent"
    },
    "COUNT": "{n} agent | {n} agents",
    "LIST": {
      "404": "Det finns inga agenter kopplade till detta konto",
      "TITLE": "Hantera agenter i ditt team",
      "DESC": "Du kan lägga till/ta bort agenter till/i ditt team.",
      "NAME": "Namn",
      "EMAIL": "E-POST",
      "STATUS": "Status",
      "ACTIONS": "Åtgärder",
      "VERIFIED": "Verifierad",
      "VERIFICATION_PENDING": "Verifiering väntar",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "Lägg till agent till ditt team",
      "DESC": "Du kan lägga till personer som kommer att kunna hantera stöd för dina inkorgar.",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "FORM": {
        "NAME": {
          "LABEL": "Agentens namn",
          "PLACEHOLDER": "Ange ett namn på agenten"
        },
        "AGENT_TYPE": {
          "LABEL": "Roll",
          "PLACEHOLDER": "Välj en typ",
          "ERROR": "Roll krävs"
        },
        "EMAIL": {
          "LABEL": "E-postadress",
          "PLACEHOLDER": "Ange en e-postadress till agenten"
        },
        "SUBMIT": "Lägg till agent"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agenten har lagts till",
        "EXIST_MESSAGE": "E-postadressen används redan, försök med en annan e-postadress",
        "ERROR_MESSAGE": "Kunde inte ansluta till Woot Server, försök igen senare"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Radera",
      "API": {
        "SUCCESS_MESSAGE": "Agenten har tagits bort",
        "ERROR_MESSAGE": "Kunde inte ansluta till Woot Server, försök igen senare"
      },
      "CONFIRM": {
        "TITLE": "Bekräfta borttagning",
        "MESSAGE": "Är du säker på att ta bort ",
        "YES": "Ja, ta bort ",
        "NO": "Nej, behåll "
      }
    },
    "EDIT": {
      "TITLE": "Redigera agent",
      "FORM": {
        "NAME": {
          "LABEL": "Agentens namn",
          "PLACEHOLDER": "Ange ett namn på agenten"
        },
        "AGENT_TYPE": {
          "LABEL": "Roll",
          "PLACEHOLDER": "Välj en roll",
          "ERROR": "Roll krävs"
        },
        "EMAIL": {
          "LABEL": "E-postadress",
          "PLACEHOLDER": "Ange en e-postadress till agenten"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Tillgänglighet",
          "PLACEHOLDER": "Please select an availability status",
          "ERROR": "Availability is required"
        },
        "SUBMIT": "Redigera agent"
      },
      "BUTTON_TEXT": "Redigera",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Agenten uppdaterad",
        "ERROR_MESSAGE": "Kunde inte ansluta till Woot Server, försök igen senare"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Återställ lösenord",
        "ADMIN_SUCCESS_MESSAGE": "Ett e-postmeddelande med instruktioner för att återställa lösenordet har skickats till agenten",
        "SUCCESS_MESSAGE": "Agentens lösenord återställd",
        "ERROR_MESSAGE": "Kunde inte ansluta till Woot Server, försök igen senare"
      }
    },
    "SEARCH_PLACEHOLDER": "Sök efter agenter...",
    "NO_RESULTS": "No agents found matching your search",
    "SEARCH": {
      "NO_RESULTS": "Inga resultat hittades."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Inget",
      "TITLE": {
        "AGENT": "Välj agent",
        "TEAM": "Välj team"
      },
      "LIST": {
        "NONE": "Inget"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Inga agenter hittades",
          "TEAM": "Inga team hittades"
        },
        "PLACEHOLDER": {
          "AGENT": "Sök efter agenter",
          "TEAM": "Sök efter team",
          "INPUT": "Search for agents"
        }
      }
    }
  }
}
